import { useGetMyAdminProfileQuery } from '@codezo/graphql';

/**
 * Whether the signed-in admin may see the studio's financials (the dashboard's Performance tab and
 * money summaries). The backend enforces it; this only decides what to show. False until known, so
 * nothing financial flashes up for someone without access.
 */
export function useFinancialAccess() {
	const { data, loading } = useGetMyAdminProfileQuery({ fetchPolicy: 'no-cache' });
	const me = data?.getMyAdminProfile;
	return {
		canViewFinancials: me?.canViewFinancials === true,
		myAdminUserId: me?.id ?? null,
		loading,
	};
}
